import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { ModelSettingsProps } from '../../../types/reduxTypes/modelSettings';

const createReducer = <T extends SliceCaseReducers<ModelSettingsProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setModelSettingsData(state, action) {
    state.modelSettingsData = action.payload;
  },
  setModelSettingsStatus(state, action) {
    state.modelSettingsStatus = action.payload;
  }
});

export default reducers;
